import { formatDateTime } from 'features/shared/utility/dateFormatter';

export const BOOKING_COLUMNS = [
  {
    field: 'BookingAgencyID',
    headerName: 'Agency',
  },
  {
    field: 'BookingID',
    headerName: 'Booking ID',
  },
  {
    field: 'BookingType',
    headerName: 'Booking Type',
  },
  {
    field: 'BeginDate',
    valueFormatter: (params) => formatDateTime(params.value),
    headerName: 'Begin Date',
  },
  {
    field: 'ProjectedReleaseDate',
    headerName: 'Projected Release Date',
    valueFormatter: (params) => formatDateTime(params.value),
  },
  {
    field: 'ActualReleaseDate',
    headerName: 'Actual Release Date',
    valueFormatter: (params) => formatDateTime(params.value),
  },
  {
    field: 'BondAmount',
    headerName: 'Bond Amount',
  },
  {
    field: 'IsBondDenied',
    type: 'boolean',
    headerName: 'Is Bond Denied',
  },
  {
    field: 'StatuteDescription',
    headerName: 'Statute Description',
  },
];

export const BOOKING_CHARGE_COLUMNS = [
  {
    field: 'ArrestDate',
    headerName: 'Arrest Date',
    valueFormatter: (params) => formatDateTime(params.value),
  },
  {
    field: 'ArrestingAgency',
    headerName: 'Arresting Agency',
  },
  { field: 'officerName', headerName: 'Officer' },

  { field: 'RSA', headerName: 'Statute Number' },
  { field: 'StatuteDescription', headerName: 'Description' },
  { field: 'ReferenceNumber', headerName: 'Reference Number' },
  { field: 'Disposition', headerName: 'Disposition' },
  { field: 'individualBondAmount', headerName: 'Bond Amount', type: 'number' },
  { field: 'individualIsBondDenied', headerName: 'IsBondDenied', type: 'boolean' },
];
